import {Events, Config, Classes} from '../models';
import {isTouch, aspectRatio, getTopLeftOfElement, colorHelper} from '../helpers';

import PIXI from 'pixi.js/bin/pixi.min.js';
// this is buggy:
// import Pixi from 'pixi.js';

import TwistFilter from './filters/twistFilter';
import WaveFilter from './filters/WaveFilter';

import ecdFilter from './filters/ecdFilter';

// import imgA from './filters/noise/waves.jpg';
// import DisplacementFilter from './filters/CustomDisplacementFilter';

var waves = function(obj) {
	// variables, accessible anywhere in private and public functions
	// do not need to use this.[var name]
	var el,
		renderer,
		stage,
		container,
		gui,
		waves = [],
		waveContainers = [],
		waveFilters = [];

	var numWaves = 10,
		colorGroups = [
			[
				"#f274a0",
				"#a1c3d1"
			],

			[
				"#4f3850",
				"#f172a1"
			],
			[
				"#b39bc8",
				"#ad2e95"
			],
			[
				"#e64398",
				"#b39bc8"
			],
			[
				"#ad2e95",
				"#e64398"
			],
			[
				"#4f3850",
				"#a1c3d1"
			],
			[
				"#ed3da4",
				"#ad2e95"
			]
		],
		colorStepsProgress = 0,
		colorStepsMax = 200,
		colorStepsDirection = 0.25,
		// takes above array and generates steps.
		colorSteps = [];

	function init() {
		trace(' --- init waves ---');
		// assign
		el = obj.el;

		gui = document.querySelector('.gui');

		window.PIXI = PIXI;

		//renderer = PIXI.autoDetectRenderer(Config.w.w, Config.w.h, {'transparent':true, 'antialias':true} );
		renderer = PIXI.autoDetectRenderer(Config.w.w, Config.w.h, {'transparent':true} );
        el.appendChild(renderer.view);


        var gl = renderer.gl;
	  	
		// gl.disable(gl.BLEND);
		
		// gl.blendFunc(gl.ONE, gl.ZERO);
		// gl.enable(gl.DEPTH_TEST);
		
		// gl.enable(gl.BLEND);
		// gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);


		// gl.enable(gl.GL_BLEND);
		gl.blendFunc(gl.GL_SRC_ALPHA, gl.GL_ONE_MINUS_SRC_ALPHA);
	  	gl.blendEquation(gl.FUNC_ADD);


        // Stage
        stage = new PIXI.Stage(0xFF0000, true);

		// Container
        container = new PIXI.Container();
        
        stage.addChild(container);

        stage.interactive = true;

        for( var c = 0; c < colorGroups.length; c++){
        	var gradientList = gradient(colorGroups[c][0], colorGroups[c][1], colorStepsMax );
        	colorSteps.push(gradientList);
        }

        createLayers();

        _redraw();
	}

	function createLayers() {
		// var sprite = new PIXI.Sprite.fromImage(imgA);
		var cbackground = new PIXI.Graphics();
		cbackground.beginFill(0xDDDDDD);
		cbackground.moveTo(0,0);
		cbackground.lineTo(0,Config.w.h);
		cbackground.lineTo(Config.w.w,Config.w.h);
		cbackground.lineTo(Config.w.w,0);

		container.addChild(cbackground);


		// start from top down to bottom.
		for( var l = 0; l < numWaves; l++){
		// for( var l = 3; l < 4; l++){
			var waveContainer = new PIXI.Container();
			var wave = new PIXI.Graphics();
			var background = new PIXI.Graphics();

			background.beginFill( 0x333333 );
			
			background.moveTo(0,0);
			background.lineTo(0,Config.w.h);
			background.lineTo(Config.w.w,Config.w.h);
			background.lineTo(Config.w.w,0);

			background.alpha = 0.0;


			var c = l;
			if( c >= colorSteps.length ){
				c = l - colorSteps.length;
			}
			var colorGroup = colorSteps[c];


			waveContainer.width = Config.w.w;
			waveContainer.height = Config.w.h;

			// begin a green fill..
			wave.beginFill( colorGroup[0] );
			 
			// draw - change the height as needed.
			var y = (l/(numWaves)) * Config.w.h,
				h = Config.w.h * (1/numWaves);

			// start top left, clockwise
			wave.moveTo(0,0);
			// top right
			wave.lineTo(Config.w.w, 0);
			// bottom right
			wave.lineTo(Config.w.w, h);
			// bottom left
			wave.lineTo(0, h);
			// end the fill
			wave.endFill();

			wave.position.x = 0;
			wave.position.y = y;
			
			// waveContainer.filterArea = new PIXI.Rectangle(0, 0, Config.w.w, Config.w.h);
			// wave.filterArea = new PIXI.Rectangle(0, 0, Config.w.w, Config.w.h);

			// var filter = new TwistFilter();

			var uniformColorA = colorHelper.hexToUniforms(colorGroup[0]);
			var uniformColorB = colorHelper.hexToUniforms(colorGroup[1]);

			var filter = new ecdFilter({colorGroup: [uniformColorA, uniformColorB] });

			// trace( colorGroup[0]+'' );
			// trace( uniformColorA );

			filter.color = uniformColorA;


			// add it the stage so we see it on our screens..
			// waveContainer.addChild(background);
			waveContainer.addChild(wave);

			var waveTexture = waveContainer.generateTexture(renderer);
    		var waveSprite = new PIXI.Sprite(waveTexture);
    		
			// waveContainer.filters = [ filter ];
			// waveFilters.push(filter);
			
			container.addChild(waveContainer);

			waves.push(wave);
			waveContainers.push(waveContainer);
			
		}

		var filter = new ecdFilter({colorGroup: [uniformColorA, uniformColorB] });
		container.filters = [ filter ];

		filter.viewAngle = 1.01;
		filter.rate = 5.5;
		filter.baseamp = 0.75;
		filter.speed = 0.5;

		waveFilters.push(filter);

	}

	// private functions only accessible by the contents of the function, public or private
	function bindEvents(){
		// window.App.removeFromCallStack(scroll, 'scroll' );
		// window.App.removeFromCallStack(resize, 'resize' );

	}

	function remove() {

		// window.App.removeFromCallStack(scroll, 'scroll' );
		// window.App.removeFromCallStack(resize, 'resize' );

		el.remove();
	}
	
	function scroll() {

	}

	function _update() {

	}

	function resize() {

	}

	function drawLayersAtPosition() {

	}

	function _redraw() {
		// var increment = 0.5;
		var difX = ((Config.mouse.px / Config.w.w));
		var difY = ((Config.mouse.py / Config.w.h));


		for( var w = 0; w < waveFilters.length; w++){
			var wave = waves[w];
			var waveFilter = waveFilters[w];
			

			// var offsetUpdate = waveFilter.offset;
			
			
			// offsetUpdate.x -= difX * 0.05;
			// offsetUpdate.y -= difY * 0.05;

			// waveFilter.baseamp = ((difX+difY)/2) * 1.1;
			// waveFilter.speed = ( ((difX+difY)/2) * 0.5 );

			waveFilter.time += 0.005;
			//waveFilter.viewAngle = 0.01;
			// waveFilter.rate = 4.5 * ((difX+difY)/2);

			// var currentColor = waveFilter.color;

			//waveFilter.colorChange = (difX + difY) / 2;
			// waveFilter.baseamp += 0.01;
		}


		// update color layers:
		for( var l = 0; l < waveContainers.length; l++){
			var waveContainer = waveContainers[l];

			var wave = waveContainer.children[0],
				x = wave.position.x,
				y = wave.position.y,
				w = Config.w.w,
				h = Config.w.h * (1/numWaves);

			waveContainer.removeChild(wave);

			var c = l;
			if( c >= colorSteps.length ){
				c = l - colorSteps.length;
			}

			var colorGroup = colorSteps[c];
			var newWave = new PIXI.Graphics();




			newWave.beginFill( colorGroup[Math.round(colorStepsProgress)] );

			// start top left, clockwise
			newWave.moveTo(0,0);
			// top right
			newWave.lineTo(Config.w.w, 0);
			// bottom right
			newWave.lineTo(Config.w.w, h);
			// bottom left
			newWave.lineTo(0, h);
			// end the fill
			newWave.endFill();

			newWave.position.x = 0;
			newWave.position.y = y;

			// trace( wave.position.x +','+ wave.position.y +' '+wave.width+'x'+wave.height);

			waveContainer.addChild(newWave);
		}

		if( (colorStepsProgress >= colorStepsMax && colorStepsDirection > 0) || (colorStepsProgress <= 0 && colorStepsDirection < 0 ) ){
			// reverse direction!
			trace(' switch direction ');
			colorStepsDirection = colorStepsDirection * -1;
		}

		colorStepsProgress += colorStepsDirection;
			


		// gui.innerHTML  = "offset.x :"+(Math.round( offsetUpdate.x * 100) / 100);
		// gui.innerHTML += '<br/>offset.y :'+ (Math.round( offsetUpdate.y * 100) / 100);
		// gui.innerHTML += "<br/>radius :"+ (Math.round( waveFilter.radius * 100) / 100);
		// gui.innerHTML += "<br/>angle :"+(Math.round( waveFilter.angle * 100) / 100); 
		renderer.render(stage);
	}

	function gradient(startColor, endColor, steps) {
         var start = {
                 'Hex'   : startColor,
                 'R'     : parseInt(startColor.slice(1,3), 16),
                 'G'     : parseInt(startColor.slice(3,5), 16),
                 'B'     : parseInt(startColor.slice(5,7), 16)
         }
         var end = {
                 'Hex'   : endColor,
                 'R'     : parseInt(endColor.slice(1,3), 16),
                 'G'     : parseInt(endColor.slice(3,5), 16),
                 'B'     : parseInt(endColor.slice(5,7), 16)
         }
         var diffR = end['R'] - start['R'],
	         diffG = end['G'] - start['G'],
	         diffB = end['B'] - start['B'],
	         stepsHex  = new Array(),
	         stepsR    = new Array(),
	         stepsG    = new Array(),
	         stepsB    = new Array();

         for(var i = 0; i <= steps; i++) {
                 stepsR[i] = start['R'] + ((diffR / steps) * i);
                 stepsG[i] = start['G'] + ((diffG / steps) * i);
                 stepsB[i] = start['B'] + ((diffB / steps) * i);
                 stepsHex[i] = '0x' + Math.round(stepsR[i]).toString(16) + '' + Math.round(stepsG[i]).toString(16) + '' + Math.round(stepsB[i]).toString(16);
         }
         return stepsHex;
     }


	// initialize
	init();

	// public functions accessible externally.
	return {
		getEl : function() {
			return el
		},

		update : function() {
			_update();
			// resize();
		},

		destory : function() {
			remove();
		},

		redraw : function() {

			_redraw();
		}
		
	}
}

module.exports = waves;




/** WEBPACK FOOTER **
 ** ./src/js/controllers/pixiwaves.js
 **/